module.exports = __webpack_public_path__ + "img/star2.9996fa91.png";